<template>
  <!--快捷入口-->
  <div class="type-entry">
    <ul class="item-list">
      <li class="item"
        v-for="(item, index) in data"
        @click="togglePage(item, index)">
        <h4 class="item-title">{{ item.title }}</h4>
        <p class="item-desc">{{ item.desc }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { jumpLink, MtaH5ClickStat } from '@/assets/js/util'

export default {
  name: 'typeEntry',
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    togglePage (item, index) {
      // 埋点
      let obj = {}
      let key = 'c' + (index + 1)
      obj[key] = 'true'
      MtaH5ClickStat(obj)
      // 判断是否是本地路由url，是则跳转至本地路由，否则正常跳转
      jumpLink({
        vm: this,
        url: item.url,
        isReplaceRouter: false
      })
    }
  }
}
</script>

<style lang="less" scoped>
// @import "../../assets/css/variable";

.type-entry {
  .item-list {
    display: flex;
    padding: 0 30/200rem;
    flex-wrap: wrap;
    justify-content: space-between;

    .item {
      display: flex;
      justify-items: center;
      flex-direction: column;
      justify-content: center;
      width: 49%;
      height: 124/200rem;
      background: rgba(249, 249, 249, 1);
      margin-bottom: 12/200rem;
      border-radius: 8/200rem;
      padding: 0 20/200rem;

      .item-title {
        line-height: 1.2;
        padding-bottom: 8/200rem;
        font-size: 30/200rem;
        font-weight: 500;
        color: rgba(46, 46, 46, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .item-desc {
        line-height: 1.2;
        font-size: 22/200rem;
        font-weight: 300;
        color: rgba(100, 105, 122, 1);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
